var render = function render(){var _vm=this,_c=_vm._self._c;return _c('q-btn-group',_vm._l((_vm.tabs),function(tab){return _c('tab-button',{key:tab.name,attrs:{"label":tab.label,"name":tab.name,"value":_vm.value},on:{"input":function($event){return _vm.$emit('input', $event)}}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }